import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Input } from "antd";
import { useDebouncedCallback } from "use-debounce";

import { RootState } from "store/Reducers";
import { handleSetPortofolioFilter } from "../ClientSideStates";



const Search = () => {
  const { filter } = useSelector((state: RootState) => state.portofolio);
  let dispatch = useDispatch();
  const debounce = useDebouncedCallback((inputValue) => {
    let value = inputValue?.trim();
    if (value) {
      let newFilter = { ...filter };
      newFilter["Title"] = value;
       dispatch(handleSetPortofolioFilter({ filter: newFilter }));
    } else {
      let newFilter = { ...filter };
      delete newFilter["Title"];
      dispatch(handleSetPortofolioFilter({ filter: newFilter }));
    }
  }, 1000);
  let [searchValue, setSearchValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (filter) {
      setSearchValue(filter[`Title`]);
    }
  }, [filter]);

  return (
    <>
      <div className="!flex  items-center">
        <Input
          allowClear
          className="! !border-1 max-w-sm !w-full"
          placeholder={"İlan no veya ilan adıyla ara..."}
          size="large"
        
          onChange={(e) => {
            setSearchValue(e.target.value);
            debounce(e.target.value);
          }}
          value={searchValue}
        />
       
      </div>
    </>
  );
};

export default Search;
